import { AsyncButton } from "aic";
import { Modal } from "react-bootstrap";

export interface PopupAlertModalProps {
  id: string;
  show: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

/**
 * Simple alert modal with title, message, and close button.
 *
 * @param props - The component props
 * @param props.id - Unique identifier for the modal
 * @param props.show - Whether the modal is currently displayed
 * @param props.title - Modal title text
 * @param props.message - Alert message to display
 * @param props.onClose - Callback invoked when modal is closed
 */
export const PopupAlertModal = ({
  id,
  show,
  title,
  message,
  onClose,
}: PopupAlertModalProps): React.ReactElement => {
  return (
    <Modal
      id={id}
      show={show}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <AsyncButton
          id={`${id}-close`}
          variant="secondary"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
        >
          Close
        </AsyncButton>
      </Modal.Footer>
    </Modal>
  );
};

PopupAlertModal.displayName = "PopupAlertModal";
